import { InputLabel, styled } from "@mui/material";

export const PasswordInputLabel = styled(InputLabel)`
  &:not(.MuiInputLabel-shrink) {
    transform: translate(14px, 10px) scale(1);
  }
`;
